import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { PlayCircle, User, LogOut, LayoutDashboard } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const Navbar = ({ variant = 'default' }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const isLight = variant === 'light';
  const textColor = isLight ? 'text-gray-700' : 'text-white/80';
  const hoverColor = isLight ? 'hover:text-gray-900' : 'hover:text-white';
  const logoColor = isLight ? 'text-indigo-600' : 'text-white';

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="flex items-center justify-between px-8 py-5 relative z-10">
      {/* Left side */}
      <div className="flex items-center gap-8">
        {/* Logo */}
        <Link to="/" className={`${logoColor} font-bold text-3xl tracking-tight`}>
          T
        </Link>
        
        {/* How it works */}
        <button className={`flex items-center gap-2 ${textColor} ${hoverColor} transition-colors text-sm`}>
          <PlayCircle className="w-4 h-4" />
          <span>How it works</span>
        </button>
      </div>

      {/* Right side */}
      <div className="flex items-center gap-6">
        <Link to="/roles" className={`${textColor} ${hoverColor} transition-colors text-sm font-medium`}>
          Browse Roles
        </Link>
        
        {user ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button 
                variant={isLight ? 'outline' : 'outline'}
                className={isLight 
                  ? 'border-gray-300 text-gray-700 hover:bg-gray-100 rounded-full px-4 gap-2' 
                  : 'bg-transparent border-white/30 text-white hover:bg-white/10 hover:text-white rounded-full px-4 gap-2'
                }
              >
                <User className="w-4 h-4" />
                {user.name?.split(' ')[0] || 'Account'}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
              <DropdownMenuItem onClick={() => navigate('/dashboard')}>
                <LayoutDashboard className="w-4 h-4 mr-2" />
                Dashboard
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => navigate('/profile')}>
                <User className="w-4 h-4 mr-2" />
                Profile
              </DropdownMenuItem>
              <DropdownMenuItem onClick={handleLogout} className="text-red-600">
                <LogOut className="w-4 h-4 mr-2" />
                Logout
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : (
          <>
            <Link to="/login">
              <Button 
                variant="ghost" 
                className={isLight 
                  ? 'text-gray-700 hover:bg-gray-100 rounded-full px-6' 
                  : 'text-white hover:bg-white/10 rounded-full px-6'
                }
              >
                Log in
              </Button>
            </Link>
            <Link to="/register">
              <Button 
                className="bg-white text-indigo-600 hover:bg-gray-100 rounded-full px-6 font-medium"
              >
                Get Started
              </Button>
            </Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
